<template>
  <div class="upload-tooltips-modal" v-if="showModal">
    <div class="modalHeader">
      <span class="title">Upload Tooltips</span>
      <span @click="closeModal" class="btn-close float-right"><i class="fas fa-times"></i></span>
    </div>

    <div class="modalBody">
      <p class="font14">
        Select a TSV file for import. The tooltip data will be saved to the current template.
        This will also generate a default localization for all fields, replacing the localization in the current language.
        Tooltips will be automatically assigned to generated questionnaire fields. This data will replace any questionnaire data currently saved to the template.
      </p>
      <label class="small"><b>Tooltip Language</b></label>
      <select class="form-control form-control-sm" v-model="uploadLanguage">
        <option v-for="(language, index) in languages" :key="index" :value="language.code" :name="language.code">
          {{ language.code }} - {{ language.name }}
        </option>
      </select>
      <div class="uploaderBox">
        <label for="selectFilesTooltips" class="w-100 small"><b>Tooltip TSV file</b></label>
        <input accept=".tsv" type="file" id="selectFilesTooltips" value="Import" />
        <button class="btn btn-info btn-upload" @click="getJsonFile">Upload Template</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'upload-tooltips-modal',

  mounted () {
    let that = this
    this.$on('showUploadModal', function (fieldData) {
      that.showModal = true
    })

    document.addEventListener('keyup', this.keyCheck)
  },

  beforeDestroy () {
    document.removeEventListener('keyup', this.keyCheck, false)

    this.$off('showUploadModal')
  },

  data () {
    return {
      showModal: false,
      uploadLanguage: 'en',
      languages: [
        { code: 'en', name: 'English' },
        { code: 'es', name: 'Spanish' },
        { code: 'zh', name: 'Chinese' },
        { code: 'cs', name: 'Czech' },
        { code: 'da', name: 'Danish' },
        { code: 'nl', name: 'Dutch' },
        { code: 'eo', name: 'Esperanto' },
        { code: 'fi', name: 'Finnish' },
        { code: 'fr', name: 'French' },
        { code: 'ka', name: 'Georgian' },
        { code: 'de', name: 'German' },
        { code: 'el', name: 'Greek' },
        { code: 'it', name: 'Italian' },
        { code: 'ja', name: 'Japanese' },
        { code: 'ko', name: 'Korean' },
        { code: 'ku', name: 'Kurdish' },
        { code: 'fa', name: 'Perisian' },
        { code: 'pl', name: 'Polish' },
        { code: 'pt', name: 'Portugese' },
        { code: 'ro', name: 'Romanian' },
        { code: 'ru', name: 'Russian' },
        { code: 'sv', name: 'Swedish' },
        { code: 'tr', name: 'Turkish' },
        { code: 'ur', name: 'Urdu' }
      ]
    }
  },

  methods: {
    keyCheck (evt) {
      if (evt.keyCode === 27) this.closeModal()
    },

    getJsonFile () {
      const files = document.getElementById('selectFilesTooltips').files

      if (files.length !== 1) {
        return false
      }

      var fr = new FileReader()
      fr.readAsText(files.item(0))

      let that = this
      fr.onload = function (e) {
        let tooltips = e.target.result.split('\n')
        for (let i = 0; i < tooltips.length; i++) {
          let y = tooltips[i].split('\t')
          tooltips[i] = y
        }
        that.processTooltips(tooltips)
        that.closeModal()
      }
    },

    closeModal () {
      this.showModal = false
    },

    processTooltips (tooltipData) {
      let tmpTemplate = JSON.parse(JSON.stringify(this.$store.state.templates[this.$store.state.currentTemplateName]))

      for (const page in tmpTemplate['pages']) {
        if (this.$store.state.templates[this.$store.state.currentTemplateName]['pages'].hasOwnProperty(page)) {
          const fields = this.$store.state.templates[this.$store.state.currentTemplateName]['pages'][page]
          fields.forEach(field => {
            tooltipData.forEach(tooltip => {
              let tooltipId = tooltip[0].replace(/\./g, '_')
              if (tooltipId === field['id']) {
                let newLabel = field['id']
                if (field.model.length) {
                  const foundModel = JSON.parse(JSON.stringify(this.$store.getters.searchModels(field.model)))
                  if (typeof foundModel._id !== 'undefined') {
                    if (typeof foundModel.label !== 'undefined' && foundModel.label.length) newLabel = foundModel.label
                  }
                }

                field['questionHelp'] = tooltip[1]
                if (typeof field['translations'] === 'undefined' || field['translations'] === null) field['translations'] = {}
                field['translations'][this.uploadLanguage] = {
                  label: newLabel,
                  text: field['questionHelp']
                }
                if (typeof field['importedInlineHelp'] === 'undefined' || field['importedInlineHelp'] === null) field['importedInlineHelp'] = {}
                field['importedInlineHelp'][this.uploadLanguage] = {
                  label: newLabel,
                  text: field['questionHelp']
                }
              }
            })
          })
          tmpTemplate['pages'][page] = fields
        }
      }

      this.$store.commit('setCurrentTemplateData', tmpTemplate)
      this.$bus.emit('reloadQuestionnaire')
      this.$store.dispatch('saveTemplatePages')
    }
  }
}
</script>

<style lang="scss" scoped>

  .upload-tooltips-modal {
    position: fixed;
    top: 10%;
    left: 50%;
    margin-left: -25%;
    width: 50%;
    height: 350px;
    max-width: 1700px;
    border: 1px solid black;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #FFF;
    z-index: 100;
    overflow: hidden;

    .modalHeader {
      background-color: #2d5f8b;
      color: #FFF;
      font-size: 18px;
      padding: 5px 10px 5px 10px;
      height: 37px;
    }

    .btn-close {
      cursor: pointer;
      color: #FFF;
    }

    .btn-upload {
      margin: 0 auto;
      display: block;
      margin-top: 25px;
    }

    .modalBody {
      position: absolute;
      padding: 10px;
      width: 100%;
      height: calc(100% - 37px);
      overflow-y: auto;
    }

    .uploaderBox {
      margin-top: 25px;
    }
  }

  @media only screen and (max-device-width : 680px) {
    .upload-tooltips-modal {
      top: 0;
      left: 0;
      margin-left: 0;
      width: 100%;
      min-height: 100%;
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/questionnaires/UploadTooltipsModal.vue